import styled from 'styled-components';
import { Row } from 'antd';

export const Container = styled(Row)`
	padding-bottom: 2rem;
`;
